import { FC } from 'react';
import styled from 'styled-components';
import { colors } from '../colors';
import Modal from './base';
import cancelIcon from '../../assets/cancel_button.svg';
import { LoaderButton } from '../button';
import { pxToRem } from '../../utils/pxToRem';

type IAddModal = {
  closeModal: () => void;
  title?: string;
  btnTxt: string | any;
  btnClick: () => void;
  disableBtn?: boolean;
  className?: string;
  isLoading: boolean;
};
export const AddModal: FC<IAddModal> = ({
  children,
  closeModal,
  btnTxt,
  title,
  btnClick,
  disableBtn,
  className,
  isLoading
}) => {
  return (
    <Modal>
      <Container className={className}>
        <Header>
          <Title>{title}</Title>
          <CloseButton onClick={closeModal} src={cancelIcon} />
        </Header>
        <Body>{children}</Body>
        <Footer>
          <CustomLoaderButton
            isLoading={isLoading}
            type={'submit'}
            disabled={disableBtn}
            onClick={btnClick}
            buttonText={btnTxt}
          />
          {/* {btnTxt}
          </LoaderButton> */}
        </Footer>
      </Container>
    </Modal>
  );
};

const Container = styled.div`
  background-color: ${colors.white};
  display: flex;
  flex: 1;
  max-width: 793px;
  min-height: 300px;
  max-height: 90%;
  height: fit-content;
  flex-direction: column;
  border-radius: 12px;
`;
const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #d6d6d6;
  padding: 24px 40px;
`;
const Title = styled.p`
  font-style: normal;
  font-weight: 500;
  font-size: ${pxToRem(21)};
  line-height: ${pxToRem(29)};
  letter-spacing: ${pxToRem(0.15)};
  color: #27272e;
`;
const CloseButton = styled.img`
  cursor: pointer;
  border: none;
  &:hover {
    opacity: 0.7;
  }
`;
const Body = styled.div`
  flex: 1;
  max-height: calc(100% - 128px);
  overflow-y: auto;
  padding: 24px 0px;
`;
const Footer = styled(Header)`
  align-items: center;
  justify-content: center;
  border-top: 1px solid #d6d6d6;
  border-bottom: none;
  margin-bottom: 0px;
  padding: 24px 40px;
`;
const CustomLoaderButton = styled(LoaderButton)`
  max-width: 327px;
  flex: 1;
`;
